import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

import {computed, onMounted, ref} from 'vue';
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import InlineSelect from "~/core-ui/vue/ui/InlineSelect.vue";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {__} from "~/ts/library/Translate";
import OperatorApplicationSwitchConfig from "~/operatorApplication/vue/config/OperatorApplicationSwitchConfig.vue";
import AbstractOperatorApplicationDesktopPlatform
    from "~/operatorApplication/ts/platform/AbstractOperatorApplicationDesktopPlatform";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {OPERATOR_STATUS_INVISIBLE} from "~/chat/ts/data/OperatorStatus";
import NonFreeConfigOption from "~/operatorApplication/vue/config/NonFreeConfigOption.vue";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";


const __default__ = {
    name: "OperatorApplicationConfigCommon"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let autoStart = ref(false);

let configuration = computed(() => {
    return OperatorApplicationConfigInstance;
});

let isAutoStartAvailable = computed(() => {
    return OperatorApplicationPlatform.isAutoStartAvailable;
});

let isSystemIdleStateAvailable = computed(() => {
    return OperatorApplicationPlatform.isSystemIdleStateAvailable;
});

onMounted(async () => {
    autoStart.value = await OperatorApplicationPlatform.isAutoStartEnabled();
});

function updateAutoStart(value: boolean) {
    OperatorApplicationPlatform.setAutoStartEnabled(value);
}

let autoAfkDelay = computed(() => {
    let result = [];
    for (let i of [0.1, 1, 3, 5, 10, 15, 30, 60]) {
        result.push({value: i * 60, label: __("через %d мин", i)});
    }
    return result;
});

let uiScale = ref(configuration.value.uiScale);

let invisibleCustomStatusIdList = computed(() => {
    let result: { id: string, descr: string }[] = [{id: null, descr: __("Невидимый")}];
    for (let status of OperatorAccountStore.data.value.customStatusList) {
        if (status.realStatusId == OPERATOR_STATUS_INVISIBLE) {
            result.push({
                id: status.id,
                descr: status.descr
            });
        }
    }
    return result;
});

let autoInvisibleTime = computed(() => {
    let result = [{value: 30, label: __("%d секунд", 30)}];
    for (let i of [1, 2, 3, 5, 10]) {
        result.push({value: i * 60, label: __("%d мин", i)});
    }
    return result;
});

let autoInvisibleLeaveTime = computed(() => {
    let result = [];
    for (let i of [1, 2, 3, 5, 10]) {
        result.push({value: i * 60, label: __("через %d мин", i)});
    }
    return result;
});

let autoInvisibleDialogCount = computed(() => {
    let result: number[] = [];
    for (let i = 1; i <= 10; i++) {
        result.push(i);
    }
    return result;
});

let isWindows = computed(() => {
    let platform = OperatorApplicationPlatform;
    if (platform instanceof AbstractOperatorApplicationDesktopPlatform) {
        return platform.isWindows;
    }
    return false;
});

let isLinux = computed(() => {
  let platform = OperatorApplicationPlatform;
  if (platform instanceof AbstractOperatorApplicationDesktopPlatform) {
    return platform.isLinux;
  }
  return false;
});

let hasTray = computed(() => {
    return isWindows.value || isLinux.value;
});



return (_ctx: any,_cache: any) => {
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, { "label-position": "top" }, {
      default: _withCtx(() => [
        (_unref(isAutoStartAvailable))
          ? (_openBlock(), _createBlock(OperatorApplicationSwitchConfig, {
              key: 0,
              modelValue: _unref(autoStart),
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => (_isRef(autoStart) ? (autoStart).value = $event : autoStart = $event)),
                updateAutoStart
              ]
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)('Запускать программу автоматически при загрузке компьютера.')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_unref(isSystemIdleStateAvailable))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(OperatorApplicationSwitchConfig, {
                modelValue: _unref(configuration).isAutoAwayOnAfkEnabled,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(configuration).isAutoAwayOnAfkEnabled) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(__)('Автоматический переход в режим "Отошёл" после неактивности')) + " ", 1),
                  (_unref(configuration).isAutoAwayOnAfkEnabled)
                    ? (_openBlock(), _createBlock(InlineSelect, {
                        key: 0,
                        modelValue: _unref(configuration).autoAwayOnAfkIdleThreshold,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(configuration).autoAwayOnAfkIdleThreshold) = $event)),
                        options: _unref(autoAfkDelay).map(item => ({ value: item.value, label: item.label }))
                      }, null, 8, ["modelValue", "options"]))
                    : _createCommentVNode("", true),
                  _createVNode(NonFreeConfigOption, { class: "ml-1" })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(OperatorApplicationSwitchConfig, {
                modelValue: _unref(configuration).isAutoAwayOnLockEnabled,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(configuration).isAutoAwayOnLockEnabled) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(__)('Автоматический переход в режим "Отошёл" после блокировки экрана')) + " ", 1),
                  _createVNode(NonFreeConfigOption)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(OperatorApplicationSwitchConfig, {
          modelValue: _unref(configuration).darkThemeAutoChangeEnabled,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(configuration).darkThemeAutoChangeEnabled) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Автоматически включать тёмную тему при смене системной темы на тёмную')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (!_unref(configuration).darkThemeAutoChangeEnabled)
          ? (_openBlock(), _createBlock(OperatorApplicationSwitchConfig, {
              key: 2,
              modelValue: _unref(configuration).darkThemeEnabled,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(configuration).darkThemeEnabled) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)('Тёмная тема')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_unref(OperatorApplicationPlatformFactory).isNative)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: _unref(__)('Масштаб интерфейса')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_slider, {
                  modelValue: _unref(uiScale),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(uiScale) ? (uiScale).value = $event : uiScale = $event)),
                  step: 0.05,
                  min: 0.8,
                  max: 2,
                  style: {"max-width":"600px"},
                  "format-tooltip": (value) => `${Math.ceil(value * 100)}%`,
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_unref(configuration).uiScale = _unref(uiScale)))
                }, null, 8, ["modelValue", "format-tooltip"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(OperatorApplicationSwitchConfig, {
          modelValue: _unref(configuration).rememberLastOperatorStatus,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(configuration).rememberLastOperatorStatus) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Запоминать последний статус оператора')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(OperatorApplicationSwitchConfig, {
          modelValue: _unref(configuration).isShowLicenseNotificationAtTop,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(configuration).isShowLicenseNotificationAtTop) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Показывать уведомление о превышении лимита подключенных операторов')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_unref(hasTray))
          ? (_openBlock(), _createBlock(OperatorApplicationSwitchConfig, {
              key: 4,
              modelValue: _unref(configuration).minimizeToTray,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(configuration).minimizeToTray) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)('Минимизировать программу в область уведомлений.')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})